import { calcEffectiveBS } from "@/constants/game.constants"
import {
  BattleCardBreakdown,
  BattleCardView,
  BattleSideReveal,
  DigitalPassport,
  TrainingFightResult,
} from "@/types/battle"
import { mergeCardShardSlots } from "@/utils/battleCards"

function normalizeCombat(combat: BattleCardBreakdown): BattleCardBreakdown {
  return {
    ...combat,
    effectiveBS: calcEffectiveBS(combat),
  }
}

function shadowOutcome(
  outcome: TrainingFightResult["outcome"]
): TrainingFightResult["outcome"] {
  if (outcome === "WIN") return "LOSE"
  if (outcome === "LOSE") return "WIN"
  return "DRAW"
}

export function mapTrainingResult(
  result: TrainingFightResult,
  passport: DigitalPassport,
  selectedCard?: BattleCardView | null
): { yourSide: BattleSideReveal; opponentSide: BattleSideReveal } {
  const you = {
    userId: passport.user_id,
    nickname: passport.nickname,
    publicGameCode: passport.publicGameCode,
    globalPts: passport.globalPts,
    localPts: passport.localPts,
    academicLeague: passport.academicLeague,
    affiliationElement: passport.affiliationElement,
    profileFrameKey: passport.profileFrameKey,
    cityName: passport.city?.title ?? null,
  }
  const shadow = {
    userId: 0,
    nickname: result.shadowName,
    publicGameCode: "",
    globalPts: 0,
    localPts: 0,
    academicLeague: null,
    cityName: null,
  }

  return {
    yourSide: {
      player: you,
      card: mergeCardShardSlots(result.yourCard, selectedCard ?? null),
      combat: normalizeCombat(result.combat.player),
      outcome: result.outcome,
      ptsDelta: 0,
      coinsDelta: result.coinsDelta,
      rewardsApplied: result.rewardsApplied,
    },
    opponentSide: {
      player: shadow,
      card: result.shadowCard,
      combat: normalizeCombat(result.combat.opponent),
      outcome: shadowOutcome(result.outcome),
      ptsDelta: 0,
      coinsDelta: 0,
      rewardsApplied: false,
    },
  }
}
